function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Trans, useTranslation } from "react-i18next";
import { connect, useSelector } from "react-redux";
import { ButtonGroup, Fade } from "reactstrap";
import { PiInfo } from "react-icons/pi";
import NumericFormat from "./react-number-format/NumericFormat";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import Button from "./mui/material/Button";
import LoadingButton from "./mui/lab/LoadingButton";
import CircularProgressWithLogo from "./mui/material/CircularProgressWithLogo";
import InvestmentItemAvatar from "./mui/material/InvestmentItemAvatar";
import { loadQuoteByOperationTypeAndInvestmentItemIdAndCurrencyIdAndBrokerIdAndUserIdAndInvestmentItemAmount } from "../actions";
import { operationTypes, brandPrimary, brandWarning, brandDanger } from "../constants";
function QuoteButton(props) {
  var operation = props.operation,
    cashAvailable = props.cashAvailable,
    investmentItemAmountAvailable = props.investmentItemAmountAvailable,
    onClickConfirm = props.onClickConfirm,
    disabled = props.disabled,
    loading = props.loading;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var quoteCall = useSelector(function (state) {
    return state.apiCalls.loadQuoteByOperationTypeAndInvestmentItemIdAndCurrencyIdAndBrokerIdAndUserIdAndInvestmentItemAmount[[operation.type, operation.broker.id, operation.market.id, operation.currency.id, operation.investmentItem.id, operation.user.id, operation.investmentItemAmount].join("-")] || {};
  });
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    quote = _useState2[0],
    setQuote = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    timer = _useState4[0],
    setTimer = _useState4[1];
  function toggleQuote(quote) {
    setQuote(quote);
    setTimer(function (prevTimer) {
      return prevTimer + 1;
    });
    operation.quote = quote;
  }
  function loadQuote() {
    props.loadQuoteByOperationTypeAndInvestmentItemIdAndCurrencyIdAndBrokerIdAndUserIdAndInvestmentItemAmount(operation.type, operation.broker.id, operation.market.id, operation.currency.id, operation.investmentItem.id, operation.user.id, operation.investmentItemAmount).then(function (action) {
      return toggleQuote(action.response._embedded);
    });
  }
  function renderTime(_ref) {
    var remainingTime = _ref.remainingTime;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "d-flex justify-content-center"
    }, /*#__PURE__*/React.createElement(InvestmentItemAvatar, {
      size: "xl",
      investmentItem: operation.investmentItem,
      imgClassName: "shadow border-0"
    })));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center bg-transparent"
  }, quoteCall.isFetching && /*#__PURE__*/React.createElement(Fade, {
    className: "py-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(CircularProgressWithLogo, null))), !quoteCall.isFetching && !quote && /*#__PURE__*/React.createElement(Fade, {
    className: "py-5",
    style: {
      backgroundImage: "linear-gradient(rgba(255, 255, 255, .1), rgba(255, 255, 255, .1))",
      backgroundPosition: "center",
      backgroundSize: "cover",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(LoadingButton, {
    variant: "outlined",
    color: "inherit",
    size: "large",
    className: "list-item-btn",
    loading: loading,
    onClick: loadQuote,
    disabled: disabled
  }, operation.type === operationTypes.BUY ? t("components.QuoteButton.buy") : t("components.QuoteButton.sell"))), operation.type === operationTypes.BUY && /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center mt-3"
  }, /*#__PURE__*/React.createElement("span", null, t("components.QuoteButton.cashAvailable"), /*#__PURE__*/React.createElement(NumericFormat, {
    displayType: "text",
    value: cashAvailable,
    className: "me-1",
    style: {
      fontWeight: 600
    }
  }), /*#__PURE__*/React.createElement("small", null, operation.currency.unitAbbreviation))), operation.type === operationTypes.SELL && /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center mt-3"
  }, /*#__PURE__*/React.createElement("span", null, t("components.QuoteButton.investmentItemAmountAvailable"), /*#__PURE__*/React.createElement(NumericFormat, {
    displayType: "text",
    value: investmentItemAmountAvailable,
    className: "me-1",
    style: {
      fontWeight: 600
    }
  }), /*#__PURE__*/React.createElement("small", null, operation.investmentItem.unitAbbreviation)))), !quoteCall.isFetching && quote && /*#__PURE__*/React.createElement(Fade, {
    className: "py-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center align-items-center"
  }, operation.type === operationTypes.BUY && !operation.boost && quote.amount > cashAvailable ? /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement(PiInfo, {
    className: "me-2"
  }), t("components.QuoteButton.insufficientCash")) : /*#__PURE__*/React.createElement("div", {
    className: "chart-wrapper"
  }, /*#__PURE__*/React.createElement(CountdownCircleTimer, {
    key: timer,
    isPlaying: !loading,
    duration: 60,
    colors: [operation.investmentItem.brandPrimaryColorHex || brandPrimary, brandWarning, brandDanger],
    colorsTime: [40, 20, 0],
    trailStrokeWidth: 0,
    onComplete: function onComplete() {
      return toggleQuote(undefined);
    },
    size: 300
  }, renderTime))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center align-items-center mt-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "components.QuoteButton.quotePrice",
    components: {
      b: /*#__PURE__*/React.createElement("b", null),
      small: /*#__PURE__*/React.createElement("small", null),
      operationInvestmentItemAmount: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        decimalScale: operation.investmentItem.unitDecimalScale,
        value: Math.abs(operation.investmentItemAmount),
        style: {
          fontWeight: 600
        }
      }),
      quotePrice: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        decimalScale: quote.currency.unitDecimalScale,
        value: quote.price,
        style: {
          fontWeight: 600
        }
      })
    },
    values: {
      operationType: operation.type === operationTypes.BUY ? t("components.QuoteButton.buy") : t("components.QuoteButton.sell"),
      operationInvestmentItemUnitAbbreviation: operation.investmentItem.unitAbbreviation,
      operationInvestmentItemName: operation.investmentItem.name,
      quoteCurrencyUnitAbbreviation: quote.currency.unitAbbreviation
    }
  })), quote.amount && /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "components.QuoteButton.quoteAmount",
    components: {
      small: /*#__PURE__*/React.createElement("small", null),
      quoteAmount: /*#__PURE__*/React.createElement(NumericFormat, {
        displayType: "text",
        value: Math.abs(quote.amount),
        className: "mr-1",
        style: {
          fontWeight: 600
        }
      })
    },
    values: {
      quoteCurrencyUnitAbbreviation: quote.currency.unitAbbreviation
    }
  })), /*#__PURE__*/React.createElement(ButtonGroup, null, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "outlined",
    color: "inherit",
    className: "me-2",
    onClick: function onClick() {
      return toggleQuote(undefined);
    }
  }, t("components.QuoteButton.cancel")), /*#__PURE__*/React.createElement(LoadingButton, {
    type: "submit",
    variant: "contained",
    color: "secondary"
    // color={operation.investmentItem.symbol}
    ,
    style: {
      fontWeight: 600
    },
    loading: loading && quote,
    onClick: function onClick() {
      return onClickConfirm(quote);
    },
    disabled: !operation.boost && (disabled || operation.type === operationTypes.BUY && quote.amount > cashAvailable)
  }, t("components.QuoteButton.confirm")))))));
}
export default connect(undefined, {
  loadQuoteByOperationTypeAndInvestmentItemIdAndCurrencyIdAndBrokerIdAndUserIdAndInvestmentItemAmount: loadQuoteByOperationTypeAndInvestmentItemIdAndCurrencyIdAndBrokerIdAndUserIdAndInvestmentItemAmount
})(QuoteButton);
QuoteButton.propTypes = {
  operation: PropTypes.object.isRequired,
  cashAvailable: PropTypes.number.isRequired,
  investmentItemAmountAvailable: PropTypes.number.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  loadQuoteByOperationTypeAndInvestmentItemIdAndCurrencyIdAndBrokerIdAndUserIdAndInvestmentItemAmount: PropTypes.func
};